import type { PathRouteProps } from "react-router-dom";

import GroupPage from "../pages/GroupPage";
import HomePage from "../pages/home/HomePage";

import Page404 from "~/pages/404/404Page";
import AccountPage from "~/pages/AccountPage";
import AdminPage from "~/pages/AdminPage";
import DemoPage from "~/pages/DemoPage";
import HealthMetricsPage from "~/pages/HealthMetricsPage";
import { MembersPage } from "~/pages/MembersPage";
import PhAnalysisPage from "~/pages/PhAnalysisPage";
import SettingsPage from "~/pages/SettingsPage";
import SuperuserPage from "~/pages/SuperuserPage";
import { withRenderTally } from "~/utils/withRenderTally";

// Wrap all page components with render tallying
const HomePageWithTally = withRenderTally(HomePage, "HomePage");
const PhAnalysisPageWithTally = withRenderTally(PhAnalysisPage, "PhAnalysisPage");
const HealthMetricsPageWithTally = withRenderTally(HealthMetricsPage, "HealthMetricsPage");
const Page404WithTally = withRenderTally(Page404, "404Page");
const AccountPageWithTally = withRenderTally(AccountPage, "AccountPage");
const DemoPageWithTally = withRenderTally(DemoPage, "DemoPage");
const AdminPageWithTally = withRenderTally(AdminPage, "AdminPage");
const SuperuserPageWithTally = withRenderTally(SuperuserPage, "SuperuserPage");
const GroupPageWithTally = withRenderTally(GroupPage, "GroupPage");
const SettingsPageWithTally = withRenderTally(SettingsPage, "SettingsPage");

interface Props extends PathRouteProps {
  bodyPadding?: number[];
  bgColor?: string;
}

export const routes: Array<Props> = [
  {
    path: "/",
    element: <HomePageWithTally />
  },
  {
    path: "/phanalysis",
    element: <PhAnalysisPageWithTally />
  },
  {
    path: "/health-metrics",
    element: <HealthMetricsPageWithTally />
  },
  {
    path: "/health-metrics/rbti",
    element: <HealthMetricsPageWithTally />
  },
  {
    path: "/health-metrics/ph-analysis",
    element: <HealthMetricsPageWithTally />
  },
  {
    path: "/health-metrics/history",
    element: <HealthMetricsPageWithTally />
  },
  {
    path: "/health-metrics/vitals",
    element: <HealthMetricsPageWithTally />
  },
  {
    path: "/not-found",
    element: <Page404WithTally />
  }
];

export const privateRoutes: Array<Props> = [
  {
    path: "/account",
    element: <AccountPageWithTally />
  },
  {
    path: "/demo",
    element: <DemoPageWithTally />
  },
  {
    path: "/admin",
    element: <AdminPageWithTally />
  },
  {
    path: "/superuser",
    element: <SuperuserPageWithTally />
  },
  {
    path: "/members",
    element: <MembersPage />
  },
  {
    path: "/groups",
    element: <GroupPageWithTally />
  },
  {
    path: "/settings",
    element: <SettingsPageWithTally />
  }
];
